import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../services/apiService';
import cloneDeep from 'lodash/cloneDeep';
import uniqWith from 'lodash/uniqWith';
import moment from 'moment';
export default {
  name: 'ViewDigitalTwinDigitalTwinStatesOverview',
  data: function data() {
    return {
      rootItems: [],
      twinItemMapping: {},
      sidebarItems: [],
      selectedTwin: null,
      twinStates: [],
      statesTableOptions: {
        sortBy: ['combinedValue'],
        sortDesc: [true]
      },
      statesTableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 25, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      statesTableHeaders: [{
        sortable: false,
        text: '',
        value: 'properties.faIcon'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
        value: 'properties.title'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'combinedValue',
        align: 'right'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'unit'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'stateTime'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    aggregatedDTwinStates: function aggregatedDTwinStates() {
      var _this = this;

      return this.twinStates.filter(function (s) {
        return _this.isStateAggregation(s);
      });
    },
    nonAggregatedDTwinStates: function nonAggregatedDTwinStates() {
      var _this2 = this;

      return this.twinStates.filter(function (s) {
        return !_this2.isStateAggregation(s);
      });
    },
    maxHierarchyOrder: function maxHierarchyOrder() {
      return this.sidebarItems.reduce(function (a, b) {
        return Math.max(a, b.hierarchyOrder);
      }, -1);
    }
  }),
  watch: {
    statesTableOptions: {
      // eslint-disable-next-line no-unused-vars
      handler: function handler(newValue) {
        var currentSort = this.statesTableOptions.sortBy; // cannot sort by the display-date, since that does not give a valid string-order

        if (currentSort[0] === 'stateTime') {
          var newSorting = cloneDeep(newValue);
          newSorting.sortBy = ['value.time'];
          this.statesTableOptions = newSorting;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.fetchChildren();
  },
  methods: {
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }

      return '-';
    },
    relativeTime: function relativeTime(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).fromNow();
      }

      return '-';
    },
    goToTwin: function goToTwin(id) {
      window.open("#/digitaltwin-mgmt/".concat(id), '_blank');
    },
    isStateAggregation: function isStateAggregation(item) {
      if (item.properties.unit === 'State-Aggregation') {
        if ("".concat(item.value.value).trim() === '') {
          return true;
        }

        if (_typeof(item.value.value) !== 'object') {
          var jsonObj = JSON.parse(item.value.value);
          return jsonObj;
        }

        return item.value.value;
      }

      return false;
    },
    selectDigitalTwin: function selectDigitalTwin(dtwin) {
      // if a root-item is selected again, show all root-items again
      if (dtwin && this.selectedTwin && dtwin.id === this.selectedTwin.id) {
        if (!this.selectedTwin.parentId || !this.twinItemMapping[this.selectedTwin.parentId]) {
          this.selectedTwin = null;
          this.sidebarItems = cloneDeep(this.rootItems);
          return;
        } else if (this.childCount(this.selectedTwin)) {
          // select the parent, if this is not a leaf
          this.selectedTwin = cloneDeep(this.twinItemMapping[this.selectedTwin.parentId]);
        }
      } else {
        this.selectedTwin = cloneDeep(this.twinItemMapping[dtwin.id]);
      }

      if (this.childCount(this.selectedTwin)) {
        this.fetchChildren(this.selectedTwin.id, 0);
      } else {
        this.buildDisplayHierarchy();
      }
    },
    childCount: function childCount(twin) {
      return ((twin || {}).children || []).length || (twin || {}).childCount || 0;
    },
    fetchChildren: function fetchChildren(parentId, offset) {
      var _this3 = this;

      this.treeLoading = true;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      return ApiService.digitalTwinFetchChildren(this, parentId, offset).then(function (data) {
        var dtwins = cloneDeep(data.digitaltwins);
        dtwins.forEach(function (twin) {
          _this3.twinItemMapping[twin.id] = twin;
        });

        if (parentId && _this3.twinItemMapping[parentId]) {
          var parent = _this3.twinItemMapping[parentId];

          if (!parent.children) {
            parent.children = dtwins;
          } else {
            parent.children = parent.children.concat(dtwins);
          }

          parent.children = uniqWith(parent.children, function (a, b) {
            return a.id === b.id;
          });

          _this3.buildDisplayHierarchy();
        } else {
          _this3.sidebarItems = dtwins;
          _this3.rootItems = dtwins;
        }

        return dtwins;
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error');
        }
      }).finally(function () {
        _this3.treeLoading = false;
        _this3.$store.state.app.loading = false;
      });
    },
    buildDisplayHierarchy: function buildDisplayHierarchy() {
      var _this4 = this;

      this.selectedTwin = cloneDeep(this.twinItemMapping[this.selectedTwin.id]);
      ApiService.digitalTwinFetchStates(this, this.selectedTwin.id).then(function (states) {
        states.forEach(function (state) {
          var value = state.value.value;

          if (!isNaN(parseFloat(value))) {
            value = Math.round(value * 100000) / 100000;
          } else if (_typeof(value) === 'object') {
            value = JSON.stringify(value);
          }

          state.stateTime = state.value.time;
          state.combinedValue = value;
          state.unit = state.properties.unit;
        });
        _this4.twinStates = states;
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error');
        }
      });

      var findParents = function findParents(dtwinId, list) {
        var dtwin = _this4.twinItemMapping[dtwinId];

        if (dtwin.parentId && _this4.twinItemMapping[dtwin.parentId]) {
          return findParents(dtwin.parentId, [_this4.twinItemMapping[dtwin.parentId]].concat(list));
        }

        return list;
      };

      var parentItems = cloneDeep(findParents(this.selectedTwin.id, [])); // as for the last element, do not darken the parent elements any further
      // otherwise there is an ugly color-glitch when the last child is selected

      var darkenOffset = !this.selectedTwin.children || this.selectedTwin.children.length === 0 ? -1 : 0; // first show all the parents of this item, getting darker and darker

      parentItems.forEach(function (parentItem, index) {
        parentItem.class = "darken-".concat(parentItems.length - index + darkenOffset, " white--text");
        parentItem.hierarchyOrder = index;
      });
      parentItems.push(cloneDeep(this.selectedTwin));
      parentItems[parentItems.length - 1].class = this.selectedTwin.children ? 'darken-0 white--text' : null;
      parentItems[parentItems.length - 1].hierarchyOrder = parentItems.length - 1;

      if (this.selectedTwin.children) {
        var children = cloneDeep(this.selectedTwin.children);
        children.forEach(function (child) {
          child.hierarchyOrder = parentItems.length;
        });
        this.sidebarItems = parentItems.concat(children);
        return;
      }

      this.sidebarItems = parentItems;
    },
    getTwinTreeIcon: function getTwinTreeIcon(dtwin) {
      var faIcon = "fa-".concat(dtwin.data && dtwin.data.faIcon ? dtwin.data.faIcon : 'dice-d8');
      return !dtwin.parentId ? "fas ".concat(faIcon) : !dtwin.children || dtwin.children.length === 0 ? "fal ".concat(faIcon) : "fal ".concat(faIcon);
    }
  }
};